module.exports = __webpack_public_path__ + "img/badge_snowit.0c32ccb3.jpg";